import { isEmpty } from 'lodash'

const WAVEFORM_BAR_COLOR = 'rgb:282636'
const WAVEFORM_BACKGROUND_COLOR = 'transparent'
const WAVEFORM_WIDTH = '700'
const WAVEFORM_HEIGHT = '200'

const mediaUserAssetUrl = process.env.REACT_APP_ENV === 'production' ?
  'https://media.plickers.com/' : 'https://media.plickers-dev.com/'

function collapseMultipleSlashes(str) {
  return str.replace(/(^\w+:\/\/)|\/{2,}/g, (_, protocol) => (protocol || '/'))
}

function getMediaBaseUrl(options = {}) {
  const optionsToUse = { resource: 'image', delivery: 'upload', ...options }
  const resourceAndDelivery = `${optionsToUse.resource}/${optionsToUse.delivery}/`
  return collapseMultipleSlashes(`${mediaUserAssetUrl}${resourceAndDelivery}/`)
}

function composeDeliveryUrl(publicId, options = {}) {
  const transformationString = isEmpty(options.transformations) ? '' : `${options.transformations}/`
  const versionString = options.version ? `${options.version}/` : ''
  const folderPathString = options.folderPath ? `${options.folderPath}/` : ''
  const formatString = options.format ? `.${options.format}` : ''
  return collapseMultipleSlashes(`${getMediaBaseUrl(options)}${transformationString}${versionString}${folderPathString}${publicId}${formatString}`)
}

function conformDeliveryUrl(deliveryUrl) {
  // not conforming delivery url for now
  // keeping the function so that we have a central place to modify if needed
  return deliveryUrl
}

function getSoundDeliveryUrl(
  publicId,
  start = null,
  end = null,
  isClipped = false,
  withFormat = true,
) {
  const transformations = isClipped ? `so_${start},eo_${end}/` : ''
  return composeDeliveryUrl(publicId, { resource: 'video', transformations, format: withFormat ? 'mp3' : null })
}

function getSoundWaveformUrl(publicId, start = null, end = null, isClipped = false) {
  const clipString = isClipped ? `so_${start},eo_${end}/` : ''
  const transformations = `${clipString}h_${WAVEFORM_HEIGHT},w_${WAVEFORM_WIDTH},fl_waveform,co_${WAVEFORM_BAR_COLOR},b_${WAVEFORM_BACKGROUND_COLOR}/`
  return composeDeliveryUrl(publicId, { resource: 'video', transformations, format: 'png' }) // use png for Safari support
}

export {
  getSoundDeliveryUrl,
  getSoundWaveformUrl,
  conformDeliveryUrl,
}
